import ContentHeader from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import "./../Expenses/Expenses.css";
import TransactionNavigation from "../../components/Transaction-comp/Navigation/TransactionYearNavigation";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASEURL } from "../../constant/constant";
import TransactionYear from "../../components/Transaction-comp/TransactionYear";
import TransactionYearNavigation from "../../components/Transaction-comp/Navigation/TransactionYearNavigation";

const TransactionYearMain = () => {
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [year_payment_list, setYear_payment_list] = useState("");

  const YearPaymentList = async (showSkeleton = false) => {
    const auth_token = sessionStorage.getItem("auth_token");
    showSkeleton && setIsLoading(true);
    const response = await axios({
      url: BASEURL + "transaction/yearly",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: auth_token,
      },
    });
    setYear_payment_list(response.data);
    showSkeleton && setIsLoading(false);
  };

  useEffect(() => {
    YearPaymentList(true);
  }, []);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <ContentHeader setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <TransactionYearNavigation />
        </div>
        <div className="content-index">
          <div className="content-scroll">
            <div class="content-card card">
              <TransactionYear
                year_payment_list={year_payment_list}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionYearMain;
